// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  imagePrefix: 'assets/images/',
  // apiUrl: 'http://localhost:3040/local/',
  // apiUrl: 'http://localhost:3040/dev/',
  // apiUrl: 'https://ht8hzt2v2j.execute-api.ap-south-1.amazonaws.com/dev/',
  apiUrl: 'https://d1p54jp4j06wmy.cloudfront.net/',
  s3DomainURL: 'https://xpresion-files-development.s3.ap-south-1.amazonaws.com/',
  apiTokenizationEnabled: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
